import React from 'react';
import { motion } from 'framer-motion';
interface StepCardProps {
  number: number;
  text: string;
  delay?: number;
}
export function StepCard({
  number,
  text,
  delay = 0
}: StepCardProps) {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true,
    margin: '-20px',
    amount: 0.3
  }} transition={{
    duration: 0.3,
    ease: 'easeOut'
  }} className="flex items-start gap-4 md:gap-5 bg-[#FBF8F3] rounded-xl shadow-md p-4 md:p-6 border-l-4 border-[#D4A574]" data-id="element-101">
      {/* Circular numbered badge */}
      <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-[#E8B86D] via-[#D4A574] to-[#C87941] flex items-center justify-center" data-id="element-102">
        <span className="text-xl md:text-2xl font-bold text-[#2C4A3E]" data-id="element-103">
          {number}
        </span>
      </div>

      {/* Step text */}
      <p className="text-base md:text-lg leading-relaxed text-[#4A4A4A] pt-1 md:pt-3" data-id="element-104">
        {text}
      </p>
    </motion.div>;
}